import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["input", "illustrationName", "title", "description"];
import PropTypes from 'prop-types';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { isProductLogo } from '../utils/isProductLogo';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import SettingsRowWrapper from './SettingsRowWrapper';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SettingsRowLayout = _ref => {
  let {
      input,
      illustrationName,
      title,
      description
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SettingsRowWrapper, Object.assign({}, rest, {
    maxInlineSize: "600px",
    children: /*#__PURE__*/_jsxs(TFlex, {
      children: [input && /*#__PURE__*/_jsx(Box, {
        marginInlineEnd: "300",
        children: input
      }), illustrationName && /*#__PURE__*/_jsx(Illustration, {
        marginBlockStart: isProductLogo(illustrationName) ? '200' : undefined,
        marginInlineEnd: "300",
        name: illustrationName,
        blockSize: isProductLogo(illustrationName) ? '24px' : '60px'
      }), /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h6",
          use: "default",
          marginBlockEnd: "100",
          typography: "heading-50",
          children: title
        }), description]
      })]
    })
  }));
};
SettingsRowLayout.propTypes = {
  /**
   * UICheckbox or UIToggle to render for settings state.
   */
  input: PropTypes.node,
  /**
   * Illustration or logo name to render.
   */
  illustrationName: PropTypes.string,
  /**
   * Text for the setting title.
   */
  title: PropTypes.node.isRequired,
  /**
   * Description for this setting.
   */
  description: PropTypes.node
};
export default SettingsRowLayout;